import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.setExpanded(true)
    document.addEventListener("click", this.handleClickOutside)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.setExpanded(false)
    document.removeEventListener("click", this.handleClickOutside)
  }

  setExpanded(expanded) {
    const button = this.element.querySelector("[aria-haspopup]")
    if (button) button.setAttribute("aria-expanded", expanded ? "true" : "false")
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)
  }
}
